// Lib
import React, { Component } from "react";
import { Row, Col } from "reactstrap";

// Component
import Input from "@cores/components/Input";

class FormComponent extends Component {

  render() {
    return (
      <Row>
        <Col md="6" xs="12">
          <Input
            autoFocus
            required
            label="Name"
            name="name"
          />
        </Col>
        <Col md="6" xs="12">
          <Input
            required
            label="Code"
            name="code"
          />
        </Col>
      </Row>
    );
  }
}

export default FormComponent;  